import Cookies from "js-cookie";
import { Controller } from "stimulus";
import Typed from "typed.js";
import { StimulusAppBootstrapper } from "@betterment/js-runtime";
import { definitionsFromGlob } from "stimulus-vite-helpers";
import { registerSambaControllers } from "@betterment/samba-stimulus";
import * as Turbo from "@hotwired/turbo";
class adaController extends Controller {
  constructor() {
    super(...arguments);
    this.adaOpenCallback = (isDrawerOpen) => {
      if (isDrawerOpen) {
        window.adaEmbed.setMetaFields(this.metaFields);
      }
    };
  }
  connect() {
    window.adaSettings = this.adaSettings;
  }
  get adaSettings() {
    return {
      toggleCallback: this.adaOpenCallback
    };
  }
  get metaFields() {
    return {
      segment_visitor_id: Cookies.get("tt_visitor_id") || "",
      b4b_app: "true",
      ...this.params
    };
  }
  get params() {
    return JSON.parse(this.data.get("params") || "{}");
  }
}
const __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adaController
}, Symbol.toStringTag, { value: "Module" }));
class autocomplete_controller_default extends Controller {
  populateAutocompleteLabel(event) {
    requestAnimationFrame(() => {
      var _a;
      const attributeKey = "attributes";
      const labelKey = "data-autocomplete-label-param";
      const value = (_a = event.target[attributeKey][labelKey]) == null ? void 0 : _a.value;
      if (value) {
        this.searchTargets[1].placeholder = value;
      }
    });
  }
}
autocomplete_controller_default.targets = ["search"];
const __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: autocomplete_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class frame_controller_default extends Controller {
  onMissing(event) {
    event.preventDefault();
    const errorContent = this.missingTarget.content.cloneNode(true);
    this.element.replaceChildren(errorContent);
  }
}
frame_controller_default.targets = ["missing"];
const __vite_glob_0_2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: frame_controller_default
}, Symbol.toStringTag, { value: "Module" }));
class navigationController extends Controller {
  close() {
    this.element.classList.remove("is-open");
    document.body.classList.remove("u-overflowHidden");
  }
  clickAway() {
    if (this.element.classList.contains("is-open")) {
      this.close();
    }
  }
  open() {
    this.element.classList.add("is-open");
    document.body.classList.add("u-overflowHidden");
  }
}
const __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: navigationController
}, Symbol.toStringTag, { value: "Module" }));
var __accessCheck$1 = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet$1 = (obj, member, getter) => {
  __accessCheck$1(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd$1 = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet$1 = (obj, member, value, setter) => {
  __accessCheck$1(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck$1(obj, member, "access private method");
  return method;
};
var _abortController, _startPolling, startPolling_fn;
async function timeout(ms, signal) {
  return new Promise((resolve, reject) => {
    let timer;
    const onAbort = () => {
      clearTimeout(timer);
      reject(signal.reason);
    };
    const onSuccess = () => {
      signal.removeEventListener("abort", onAbort);
      resolve();
    };
    timer = setTimeout(onSuccess, ms);
    signal.addEventListener("abort", onAbort);
  });
}
async function isProcessing(url, signal) {
  const response = await fetch(url, { signal });
  const payload = await response.json();
  return payload.processing;
}
function isAbortError(error) {
  return error instanceof DOMException && error.name === "AbortError";
}
class polling_controller_default extends Controller {
  constructor() {
    super(...arguments);
    __privateAdd$1(this, _startPolling);
    __privateAdd$1(this, _abortController, void 0);
  }
  connect() {
    __privateSet$1(this, _abortController, new AbortController());
    void __privateMethod(this, _startPolling, startPolling_fn).call(this);
  }
  disconnect() {
    __privateGet$1(this, _abortController).abort();
  }
}
_abortController = /* @__PURE__ */ new WeakMap();
_startPolling = /* @__PURE__ */ new WeakSet();
startPolling_fn = async function() {
  const { signal } = __privateGet$1(this, _abortController);
  try {
    while (await isProcessing(this.urlValue, signal)) {
      await timeout(this.intervalValue, signal);
    }
    window.location.reload();
  } catch (error) {
    if (!isAbortError(error)) {
      throw error;
    }
  }
};
polling_controller_default.values = {
  url: String,
  interval: { type: Number, default: 1e3 }
};
const __vite_glob_0_4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: polling_controller_default,
  timeout
}, Symbol.toStringTag, { value: "Module" }));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _typed, _onComplete;
class typed_controller_default extends Controller {
  constructor() {
    super(...arguments);
    __privateAdd(this, _typed, void 0);
    __privateAdd(this, _onComplete, () => {
      if (this.redirectValue) {
        window.location.assign(this.redirectValue);
      }
    });
  }
  connect() {
    __privateSet(this, _typed, new Typed(this.element, {
      strings: this.messagesValue,
      typeSpeed: 40,
      backSpeed: 40,
      showCursor: true,
      onComplete: __privateGet(this, _onComplete)
    }));
  }
  disconnect() {
    __privateGet(this, _typed).destroy();
  }
}
_typed = /* @__PURE__ */ new WeakMap();
_onComplete = /* @__PURE__ */ new WeakMap();
typed_controller_default.values = {
  redirect: String,
  messages: {
    type: Array,
    default: ["Just a moment", "This could take a few minutes..."]
  }
};
const __vite_glob_0_5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: typed_controller_default
}, Symbol.toStringTag, { value: "Module" }));
const appConfig = window.BMT.config;
function startTurbo() {
  Turbo.session.drive = false;
  Turbo.start();
  document.addEventListener("turbo:frame-missing", async (event) => {
    const { response } = event.detail;
    if (!event.defaultPrevented && response.status >= 500) {
      event.preventDefault();
      const responseHTML = await response.clone().text();
      Turbo.visit(window.location.href, { response: { responseHTML } });
    }
  });
}
const controllers = /* @__PURE__ */ Object.assign({
  "./src/stimulus/controllers/ada-controller.ts": __vite_glob_0_0,
  "./src/stimulus/controllers/autocomplete-controller.ts": __vite_glob_0_1,
  "./src/stimulus/controllers/frame-controller.ts": __vite_glob_0_2,
  "./src/stimulus/controllers/navigation-controller.ts": __vite_glob_0_3,
  "./src/stimulus/controllers/polling-controller.ts": __vite_glob_0_4,
  "./src/stimulus/controllers/typed-controller.ts": __vite_glob_0_5
});
const definitions = definitionsFromGlob(controllers);
const sentryAppConfig = {
  sentryApiToken: appConfig.sentryApiToken || "",
  sentryEnvironment: appConfig.sentryEnvironment || "development",
  sentryRelease: appConfig.sentryRelease || "",
  user: appConfig.user,
  sentryWhitelistUrls: ["betterment.com"],
  isReplayEnabled: false
};
async function startStimulusApplication() {
  const bootstrapper = new StimulusAppBootstrapper(
    definitions,
    sentryAppConfig
  );
  const application = await bootstrapper.initialize();
  registerSambaControllers(application);
}
export {
  appConfig,
  startStimulusApplication,
  startTurbo
};
//# sourceMappingURL=b4b.mjs.map
